import type { TableColumnMeta } from '../common/ColumnSelector';

/** Column catalogue for the DPS enrollment table, grouped by category. */
export const DPS_COLUMN_METADATA: TableColumnMeta[] = [
  { id: 'select', label: 'Select', category: 'Actions', alwaysVisible: true },
  { id: 'name', label: 'Device Name', category: 'Basic Info' },
  { id: 'device_id', label: 'Device ID', category: 'Basic Info' },
  { id: 'customer_name', label: 'Customer', category: 'Basic Info' },
  { id: 'status', label: 'Device Status', category: 'Basic Info' },
  { id: 'registration_id', label: 'Registration ID', category: 'Attestation' },
  { id: 'has_tpm', label: 'TPM', category: 'Attestation' },
  { id: 'dps_enrollment_status', label: 'Enrollment Status', category: 'Azure DPS' },
  { id: 'dps_environment', label: 'DPS Environment', category: 'Azure DPS' },
  { id: 'dps_assigned_hub', label: 'Assigned Hub', category: 'Azure DPS' },
  { id: 'dps_enrolled_at', label: 'Enrolled At', category: 'Azure DPS' },
  { id: 'dps_last_error', label: 'Last Error', category: 'Azure DPS' },
];

/** What an operator wants on screen without scrolling sideways. */
export const DPS_DEFAULT_COLUMNS = [
  'select',
  'name',
  'customer_name',
  'registration_id',
  'dps_enrollment_status',
  'dps_environment',
  'dps_enrolled_at',
  'dps_last_error',
];

/** Presets for this table. The device table's presets name device columns that
 *  do not exist here, so the selector takes these instead. */
export const DPS_COLUMN_PRESETS = {
  minimal: {
    name: 'Minimal',
    columns: ['name', 'dps_enrollment_status', 'dps_environment'],
  },
  enrollment: {
    name: 'Enrollment',
    columns: [
      'name',
      'registration_id',
      'dps_enrollment_status',
      'dps_environment',
      'dps_enrolled_at',
    ],
  },
  troubleshooting: {
    name: 'Troubleshooting',
    columns: [
      'name',
      'device_id',
      'dps_enrollment_status',
      'dps_assigned_hub',
      'dps_last_error',
      'has_tpm',
    ],
  },
  full: {
    name: 'Full View',
    columns: 'all' as const,
  },
};
